import { render, staticRenderFns } from "./SpaceManagement.vue?vue&type=template&id=8db7d9e8&scoped=true"
import script from "./SpaceManagement.vue?vue&type=script&lang=js"
export * from "./SpaceManagement.vue?vue&type=script&lang=js"
import style0 from "./SpaceManagement.vue?vue&type=style&index=0&id=8db7d9e8&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db7d9e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8db7d9e8')) {
      api.createRecord('8db7d9e8', component.options)
    } else {
      api.reload('8db7d9e8', component.options)
    }
    module.hot.accept("./SpaceManagement.vue?vue&type=template&id=8db7d9e8&scoped=true", function () {
      api.rerender('8db7d9e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/availableSpaces/SpaceManagement.vue"
export default component.exports